import { Component, OnInit } from '@angular/core';
import { EventService } from '../core/services/event.service';
import { LAYOUT_VERTICAL, LAYOUT_HORIZONTAL } from './layout.model';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

/**
 * Layout Component
 */
export class LayoutComponent implements OnInit {

  private readonly layoutModeStorageKey = 'layout-mode';
  isCondensed = false;
  layoutType!: string;
  constructor(private eventService: EventService) { }

  ngOnInit(): void {
    this.layoutType = LAYOUT_VERTICAL;
    this.initLayout();
    this.eventService.subscribe('changeLayout', (layout) => {
      this.layoutType = layout;
      this.initLayout();
    });
  }

  onToggleMobileMenu() {
    if (this.layoutType === LAYOUT_HORIZONTAL) {
      this.onToggleMobileMenuHorizontal();
    } else if (this.layoutType === LAYOUT_VERTICAL) {
      this.onToggleMobileMenuVertical();
    }

  }

  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    const rightBar = document.getElementById('theme-settings-offcanvas');
    if (rightBar != null) {
      rightBar.classList.toggle('show');
      rightBar.setAttribute('style', "visibility: visible;");

    }
  }

  initLayout() {
    if (this.layoutType === LAYOUT_HORIZONTAL) {
      this.initHorizontal();
    } else if (this.layoutType === LAYOUT_VERTICAL) {
      this.initVertical();
    }
  }

  initVertical() {
    document.documentElement.setAttribute('data-layout', 'vertical');
    document.documentElement.setAttribute('data-topbar', 'light');
    document.documentElement.setAttribute('data-sidebar', 'dark');
    document.documentElement.setAttribute('data-layout-style', 'default');
    document.documentElement.setAttribute('data-layout-mode', 'light');
    document.documentElement.setAttribute('data-layout-width', 'fluid');
    document.documentElement.setAttribute('data-layout-position', 'fixed');
    document.documentElement.setAttribute('data-sidebar-image', 'none');
    this.applyPersistedMode();

    window.addEventListener('resize', function () {
      if (window.screen.width <= 767) {
        document.documentElement.setAttribute('data-sidebar-size', '');
      }
      else if (window.screen.width <= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      else if (window.screen.width >= 1024) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
    })

  }

  initHorizontal() {
    document.documentElement.setAttribute('data-layout', 'horizontal');
    document.documentElement.setAttribute('data-topbar', 'light');
    document.documentElement.setAttribute('data-sidebar', 'dark');
    document.documentElement.setAttribute('data-sidebar-size', 'lg');
    document.documentElement.setAttribute('data-layout-style', 'default');
    document.documentElement.setAttribute('data-layout-mode', 'light');
    document.documentElement.setAttribute('data-layout-width', 'fluid');
    document.documentElement.setAttribute('data-layout-position', 'fixed');
    this.applyPersistedMode();
  }

  private applyPersistedMode() {
    const persistedMode = localStorage.getItem(this.layoutModeStorageKey);
    if (persistedMode === 'light' || persistedMode === 'dark') {
      document.documentElement.setAttribute('data-layout-mode', persistedMode);
    }
  }

  onToggleMobileMenuVertical() {
    const currentSIdebarSize = document.documentElement.getAttribute("data-sidebar-size");
    if (window.screen.width >= 767) {
      if (currentSIdebarSize == null) {
        (document.documentElement.getAttribute('data-sidebar-size') == null || document.documentElement.getAttribute('data-sidebar-size') == "lg") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg')
      } else if (currentSIdebarSize == "md") {
        (document.documentElement.getAttribute('data-sidebar-size') == "md") ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'md')
      } else {
        (document.documentElement.getAttribute('data-sidebar-size') == "sm") ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm')
      }
    }

    if (window.screen.width <= 767) {
      document.body.classList.toggle('vertical-sidebar-enable');
    }
    this.isCondensed = !this.isCondensed;
  }

  onToggleMobileMenuHorizontal() {
    if (window.screen.width <= 1024) {
      document.body.classList.toggle('menu');
    }
  }
  /**
  * Check if the vertical layout is requested
  */
  isVerticalLayoutRequested() {
    return this.layoutType === LAYOUT_VERTICAL;
  }

  /**
   * Check if the horizontal layout is requested
   */
  isHorizontalLayoutRequested() {
    return this.layoutType === LAYOUT_HORIZONTAL;
  }


}
